export class NgxMatPage {
  constructor(
      public id: number,
      public label: string | number,
      public disabled: boolean = false
  ) { }
}
